/* RAYZ bag: the prototype's drawer on Shopify's AJAX cart.
   It registers as <cart-drawer> and keeps Dawn's contract (getSectionsToRender, renderContents,
   setActiveElement, open), so Dawn's product forms, quick add and Standard Actions use it too. */
(function () {
  let tt;
  window.RayzToast = function (msg) {
    const t = document.querySelector('.rz-toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('is-on'), 2200);
  };

  const route = (key, fallback) => ((window.routes && window.routes[key]) || fallback);
  const SECTION = 'rayz-cart-drawer';

  class RayzCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.rz-drawer');
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-rz-cart-close]')) { e.preventDefault(); this.close(); return; }
        const q = e.target.closest('[data-rz-line]');
        if (q) this.change(+q.dataset.rzLine, +q.dataset.rzQty);
      });
      document.addEventListener('click', (e) => {
        const o = e.target.closest('[data-rz-cart-open]');
        if (!o) return;
        e.preventDefault(); this.setActiveElement(o); this.open();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      this.panel.inert = true;
    }

    open() {
      this.classList.add('is-open');
      this.panel.inert = false;
      this.panel.setAttribute('aria-hidden', 'false');
      const f = this.panel.querySelector('[data-rz-cart-close]');
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.panel.inert = true;
      this.panel.setAttribute('aria-hidden', 'true');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }

    setActiveElement(el) { this.activeElement = el; }

    getSectionsToRender() {
      return [{ id: SECTION, selector: '#RayzCartInner' }, { id: 'cart-icon-bubble' }];
    }

    render(sections) {
      if (!sections) return;
      const before = document.querySelector('#RayzCartInner [data-rz-rewards]');
      const wonBefore = before ? +before.dataset.won : null;
      queueMicrotask(() => {
        const after = document.querySelector('#RayzCartInner [data-rz-rewards]');
        if (!after || wonBefore === null) return;
        const w = +after.dataset.won;
        if (w > wonBefore) {
          const chips = [...after.querySelectorAll('.rz-jr-chips li.is-on')];
          const chip = chips[chips.length - 1];
          if (!chip) return;
          chip.classList.add('is-new');
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            for (let i = 0; i < 12; i++) {
              const s = document.createElement('i'); s.className = 'rz-spark'; s.textContent = i % 3 ? '✦' : '✧';
              const a = (Math.PI * 2 * i) / 12, d = 34 + Math.random() * 26;
              s.style.setProperty('--x', `${Math.cos(a) * d}px`); s.style.setProperty('--y', `${Math.sin(a) * d}px`); s.style.animationDelay = `${Math.random() * 120}ms`;
              chip.appendChild(s); setTimeout(() => s.remove(), 1400);
            }
          }
          RayzToast(`${chip.querySelector('.rz-jr-e').textContent} ${chip.querySelector('.rz-jr-t').textContent} unlocked`);
        }
      });
      this.getSectionsToRender().forEach((s) => {
        const html = sections[s.id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector(s.selector || '.shopify-section');
        const mount = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (src && mount) mount.innerHTML = src.innerHTML;
      });
      document.dispatchEvent(new CustomEvent('rz:cart-rendered'));
    }

    // Dawn's product-form.js calls this after /cart/add; Dawn's own drawer opens here too.
    renderContents(parsed) {
      this.render(parsed.sections);
      this.open();
    }

    notify(cartData, source) {
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'rayz-cart', cartData });
    }

    async post(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
      });
      return res.json();
    }

    // Used by the RAYZ sections: add quietly, confirm with the toast (as in the prototype).
    async add(id, quantity, label) {
      try {
        const res = await this.post(`${route('cart_add_url', '/cart/add')}.js`, { items: [{ id, quantity: quantity || 1 }] });
        if (res.status) { RayzToast(res.description || res.message); return; }
        this.render(res.sections);
        RayzToast(`${label || 'Item'} · ${this.dataset.addedLabel || 'added to bag'}`);
        this.notify(res);
      } catch (e) {
        RayzToast(window.cartStrings ? cartStrings.error : 'Something went wrong. Please try again.');
      }
    }

    async change(line, quantity) {
      const items = this.querySelector('.rz-items');
      if (items) items.classList.add('is-busy');
      try {
        const res = await this.post(`${route('cart_change_url', '/cart/change')}.js`, { line, quantity });
        if (res.status || res.errors) {
          RayzToast(res.description || res.message || res.errors);
          if (items) items.classList.remove('is-busy');
          return;
        }
        this.render(res.sections);
        this.notify(res);
      } catch (e) {
        if (items) items.classList.remove('is-busy');
        RayzToast(window.cartStrings ? cartStrings.error : 'Something went wrong. Please try again.');
      }
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', RayzCartDrawer);

  // RAYZ quick-add buttons outside the theatre (sets)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rz-add]');
    if (!b) return;
    e.preventDefault();
    const cart = document.querySelector('cart-drawer');
    const id = b.dataset.rzAdd;
    if (!id) { RayzToast(b.dataset.demoMsg || 'Choose a product for this block in the theme editor'); return; }
    if (cart && cart.add) { cart.add(+id, 1, b.dataset.rzName); return; }
    // No drawer (cart type set to page or notification): add, then go to the cart page.
    fetch(`${route('cart_add_url', '/cart/add')}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .finally(() => { location.href = route('cart_url', '/cart'); });
  });

  // Keep the drawer in step when something other than RAYZ changes the cart (e.g. the cart page).
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source === 'rayz-cart' || event.source === 'product-form' || event.source === 'external-refresh') return;
      fetch(`${route('cart_url', '/cart')}?sections=${SECTION},cart-icon-bubble`)
        .then((r) => r.json())
        .then((sections) => { const cart = document.querySelector('cart-drawer'); if (cart && cart.render) cart.render(sections); })
        .catch(() => {});
    });
  });
})();
